import React from "react";

interface FormInputProps {
  label: string;
  unit?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  error?: string;
  required?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  unit,
  value,
  onChange,
  placeholder = "",
  type = "text",
  className = "",
  error,
  required = false,
}) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label className="text-sm 3xl:text-base font-medium font-inter text-[#1F1F1F]">
        {label}
        {unit && (
          <span className="ml-1 text-xs 3xl:text-sm font-normal text-[#646464]">
            ({unit})
          </span>
        )}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full px-3 py-2 border rounded-md text-sm 3xl:text-base font-inter text-[#1F1F1F] placeholder:text-[#9E9E9E] outline-none transition-colors bg-white ${
          error
            ? "border-red-400 focus:border-red-500"
            : "border-[#E0E0E0] focus:border-[#0DB5B5]"
        }`}
      />
      {error && (
        <p className="text-xs 3xl:text-sm text-red-500 font-inter">{error}</p>
      )}
    </div>
  );
};

export default FormInput;
